// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "" + ({"125":"component---src-pages-404-js","293":"component---src-pages-index-js"}[chunkId] || chunkId) + "-" + {"125":"6a310b5174b0ae1f0c5f","293":"65c2d91562c8a5da88b3","454":"4433c5411aee1cb73b76"}[chunkId] + ".js";
};